import React from 'react';
import { DeviceType } from '../enum/EnumRepository';
import { useDeviceStore } from '../store/deviceStore';

interface MobileOnlyWrapperProps {
  children: React.ReactNode;
}

const MobileOnlyWrapper: React.FC<MobileOnlyWrapperProps> = ({ children }) => {
  const { deviceType } = useDeviceStore();

  if (deviceType !== DeviceType.MOBILE) {
    return null;
  }

  return <>{children}</>;
}

export default MobileOnlyWrapper;